import { LabelValuePair } from './globals.type';
import { StoreType } from './store.type';

export enum TestCourseGroupTypeEnum {
  SKILL = 'skill',
  ROAD = 'road',
}

export interface GetLicenseTestCourseListParams {
  page?: number;
  limit?: number;
  siDo?: number;
  siGunGu?: number;
  keyword?: string;
  /** SEO 지역 문자열("시도 시군구 읍면동"). 지정 시 해당 지역 기준 거리순 정렬 */
  region?: string;
}

export interface BaseAcademyEntity {
  id: number;
  title: string;
  roadAddress: string;
  phone: string;
  photoPath?: string;
}

export interface AcademyEntity extends BaseAcademyEntity {
  url: string;
  jibunAddress: string;
  description: string;
  photoPaths: string[];
  seoTitle?: string;
  seoDescription?: string;
  seoKeywords?: string;
}

export interface LicenseTestCourseListResponse {
  totalCount: number;
  limit: number;
  academies: AcademyEntity[];
}

export interface SubwayEntity {
  detail: string;
  subwayInfo: SubwayInfoEntity;
}

export interface SubwayInfoEntity {
  city: string;
  color: string;
  line: string;
}

export interface TestCourseEntity {
  title: string;
  content: string;
  youtubeVideoId?: string;
  imagePath?: string;
  sequence: number;
}

export interface TestCourseGroupEntity {
  group: TestCourseGroupTypeEnum;
  testCourses: TestCourseEntity[];
}

export interface TestCourseArticleEntity {
  id: number;
  title: string;
  thumbPath?: string;
  datetime: string;
  /** 게시판 타입(test_course_skill_analysis=장내기능 / test_course_road_analysis=도로주행) */
  boardType?: string;
}

/** 코스분석 게시글에 연결된 시험장 필터 옵션 */
export interface TestCourseArticleAcademyEntity {
  id: number;
  title: string;
}

/** 시험장별 게시판 타입 옵션 (academy-board-types API) */
export interface TestCourseArticleBoardTypeOption {
  boardType: string;
  title: string;
}

export interface TestCourseArticleAcademyBoardTypesRow {
  academyId: number;
  boardTypes: TestCourseArticleBoardTypeOption[];
}

export interface NearStoreEntity {
  id: number;
  name: string;
  type: StoreType;
  photoPath?: string;
  summaryAddress: string;
  distance: number;
}

export interface LicenseTestCourseDetailEntity extends AcademyEntity {
  subways: SubwayEntity[];
  testCourseGroups: TestCourseGroupEntity[];
  articles: TestCourseArticleEntity[];
  nearStores: NearStoreEntity[];
}

export interface LicenseTestCourseRegionEntity extends LabelValuePair {
  id: number;
  name: string;
  subRegions?: LicenseTestCourseRegionEntity[];
}
